import React, { CSSProperties } from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import './index.scss';

export interface IStreamingTextProps {
  /** 显示的文字内容，默认读取 i18n: dba_data_loading（数据加载中...） */
  text?: string;
  /** 组件类名 */
  className?: string;
  /** 自定义样式 */
  style?: CSSProperties;
  /** 文字颜色 */
  textColor?: string;
  /** 流光颜色 */
  streamColor?: string;
  /** 动画持续时间（秒） */
  duration?: number;
  /** 动画延迟时间（秒） */
  delay?: number;
  /** 是否循环播放 */
  loop?: boolean;
  /** 是否自动播放 */
  autoPlay?: boolean;
  /** 字体大小 */
  fontSize?: string | number;
  /** 字体粗细 */
  fontWeight?: string | number;
  /** 使用场景：think 为思考区内展示，无上边距 */
  from?: 'think';
}

export const StreamingText: React.FC<IStreamingTextProps> = ({
  text,
  className,
  style,
  textColor = '#666',
  streamColor = '#1890ff',
  duration = 2,
  delay = 0,
  loop = true,
  autoPlay = true,
  fontSize = '14px',
  fontWeight = 'normal',
  from,
}) => {
  const { formatMessage } = useIntl();
  const displayText = text ?? formatMessage({ id: 'dba_data_loading' });
  const customStyle = {
    '--text-color': textColor,
    '--stream-color': streamColor,
    '--animation-duration': `${duration}s`,
    '--animation-delay': `${delay}s`,
    '--font-size': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,
    '--font-weight': fontWeight,
    ...style,
  };

  return (
    <div
      className={classNames(
        'dba-streaming-text',
        {
          'dba-streaming-text--loop': loop,
          'dba-streaming-text--auto-play': autoPlay,
          'dba-streaming-text--think': from === 'think',
        },
        className
      )}
      style={customStyle}
    >
      <span className="dba-streaming-text__content">
        {displayText}
      </span>
    </div>
  );
};

export default StreamingText;